<template>
  <section class="invoice" v-if="data">
    <div class="invoice-block">
      <div class="invoice-block-one invoice-title invoice-block-one__grow">
        Счет на оплату №
        <span
          class="invoice-number"
          :class="{ 'number-empty': data.name == '' }"
          >{{ data.name }}</span
        >
        от {{ data.date | moment('DD.MM.YYYY')}}
      </div>
      <div class="invoice-block-one invoice-image" v-if="data.qr == '1'">
        <vue-qrcode :value="qrdata" :options="opts"></vue-qrcode>
      </div>
    </div>
    <div class="invoice-block">
      <div class="invoice-block-one invoice-block-one__small invoice-bold">
        {{ $root.app.types.find((x) => x.id == data.me.type).name }}
      </div>
      <div class="invoice-block-one invoice-block-one__grow">
        {{ company.name.full_with_opf }}, ИНН: {{ company.inn }},
        <span v-if="company.kpp">КПП:{{ company.kpp }},</span>
        <span
          >{{ company.inn.length == 10 ? "ОГРН" : "ОГРНИП" }}:
          {{ company.ogrn }},</span
        >
        Юридический адрес:
        {{ company.address.unrestricted_value }}
      </div>
    </div>
    <div class="invoice-block">
      <div class="invoice-table">
        <div class="invoice-table-line">
          <div class="invoice-table-one">
            <div class="invoice-table-one__bank">
              <div class="invoice-name invoice-bold">
                <span>{{ bank.data.name.payment }}</span>
              </div>
              <div class="invoice-name"><span>Банк получателя</span></div>
            </div>
          </div>
          <div class="invoice-table-one">
            <div class="invoice-table-one__small invoice-table-one__shw">
              <span>БИК</span>
            </div>
            <div class="invoice-table-one__small invoice-table-one__shw">
              <span>Сч. №</span>
            </div>
          </div>
          <div class="invoice-table-one">
            <div class="invoice-table-one__small">
              <span>{{ bank.data.bic }}</span>
            </div>
            <div
              class="invoice-table-one__small invoice-table-one__small-noborder"
            >
              <span>{{
                bank.data.correspondent_account | VMask("#####.###.#.###########")
              }}</span>
            </div>
          </div>
        </div>
        <div class="invoice-table-line">
          <div class="invoice-table-one">
            <div class="invoice-table-one__company">
              <div class="invoive-table-one__sl">
                <div class="invoive-table-one__v">
                  <div class="invoive-table-v__title"><span>ИНН</span></div>
                  <div class="invoive-table-v__val">
                    <span>{{ company.inn }}</span>
                  </div>
                </div>

                <div class="invoive-table-one__v">
                  <div class="invoive-table-v__title"><span>КПП</span></div>
                  <div class="invoive-table-v__val">
                    <span>{{ company.kpp ? company.kpp : "—" }}</span>
                  </div>
                </div>
              </div>
              <div class="invoice-name invoice-bold">
                <span>{{ company.name.full_with_opf }}</span>
              </div>
              <div class="invoice-name"><span>Получатель</span></div>
            </div>
          </div>
          <div class="invoice-table-one">
            <div
              class="invoice-table-one__small invoice-table-one__bh invoice-table-one__shw"
            >
              <span>Сч. №</span>
            </div>
          </div>
          <div class="invoice-table-one">
            <div class="invoice-table-one__small invoice-table-one__bh">
              <span>{{ bank.rs }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="invoice-block">
      <div class="invoice-block-one invoice-block-one__small invoice-bold">
        {{ $root.app.types_b.find((x) => x.id == data.customer.type).name }}
      </div>
      <div class="invoice-block-one invoice-block-one__grow">
        {{ data.customer.data.name.full_with_opf }}, ИНН:
        {{ data.customer.data.inn }},
        <span v-if="data.customer.data.kpp"
          >КПП:{{ data.customer.data.kpp }},</span
        >
        <span
          >{{ company.inn.length == 10 ? "ОГРН" : "ОГРНИП" }}:
          {{ data.customer.data.ogrn }},</span
        >
        Юридический адрес: {{ data.customer.data.address.unrestricted_value }}
      </div>
    </div>
    <div class="invoice-block" v-if="data.found">
      <div class="invoice-block-one invoice-block-one__small invoice-bold">
        Основание
      </div>
      <div class="invoice-block-one invoice-block-one__grow">
        {{ data.found }}
      </div>
    </div>

    <div class="invoice-block">
      <div class="invoice-items">
        <div class="invoice-items-one invoice-items-one__title">
          <div class="invoice-items-elem invoice-items-elem__index">№</div>
          <div class="invoice-items-elem invoice-items-elem__name">
            Наименование товаров, работ, услуг
          </div>
          <div class="invoice-items-elem invoice-items-elem__count">Кол-во</div>
          <div class="invoice-items-elem invoice-items-elem__counttype">
            Ед. изм
          </div>
          <div class="invoice-items-elem invoice-items-elem__cost">Цена</div>
          <div class="invoice-items-elem invoice-items-elem__sum">Всего</div>
        </div>
        <div
          class="invoice-items-one"
          v-for="(elem, index) in data.items"
          :key="elem.id"
        >
          <div class="invoice-items-elem invoice-items-elem__index">
            {{ index + 1 }}
          </div>
          <div class="invoice-items-elem invoice-items-elem__name">
            {{ elem.name }}
          </div>
          <div class="invoice-items-elem invoice-items-elem__count">
            {{ elem.count }}
          </div>
          <div class="invoice-items-elem invoice-items-elem__counttype">
            {{ elem.type }}
          </div>
          <div class="invoice-items-elem invoice-items-elem__cost">
            {{ elem.cost | money }}
          </div>
          <div class="invoice-items-elem invoice-items-elem__sum">
            {{ (elem.cost * elem.count) | money }}
          </div>
        </div>
        <div
          class="invoice-items-one invoice-items-finally"
          v-if="$root.app.user.nds == '1'"
        >
          <div class="invoice-items-elem invoice-items-elem__title">Итого</div>
          <div class="invoice-items-elem invoice-items-elem__sum">
            {{ sum | money }}
          </div>
        </div>
        <div class="invoice-nds-lines" v-if="$root.app.user.nds == '1'">
          <div
            class="invoice-items-one invoice-items-finally"
            v-for="el in nds_data"
            :key="el.id"
          >
            <div class="invoice-items-elem invoice-items-elem__title">
              В том числе НДС {{ el.id }}%
            </div>
            <div class="invoice-items-elem invoice-items-elem__sum">
              {{ el.sum | money }}
            </div>
          </div>
        </div>
        <div class="invoice-items-one invoice-items-finally">
          <div class="invoice-items-elem invoice-items-elem__title">
            Итого к оплате
          </div>
          <div class="invoice-items-elem invoice-items-elem__sum">
            {{ ((data.nds == "0" ? nds : 0) + sum) | money }}
          </div>
        </div>
      </div>
    </div>
    <div class="invoice-block invoice-bottom">
      <div class="text-left">
        Всего наименований {{ data.items.length }} на сумму {{ sum_b }} рублей
        {{ sum_k < 10 ? "0" + sum_k : sum_k }} копеек
        <div class="sum-text-label">
          <strong>{{ sum_text }}</strong>
        </div>
        <div class="sum-text-label" v-if="$root.app.user.nds == '0'">
          <strong>{{ $root.app.user.nds_reason }}</strong>
        </div>
      </div>
    </div>
    <div
      class="invoice-block invoice-bottom invoice-lrt"
      v-if="data.description || data.purpose"
    >
      <div class="invoice-block-one invoice-block-one__small invoice-bold">
        Условие оплаты
      </div>
      <div
        class="invoice-block-one invoice-block-one__description invoice-block-one__grow"
      >
        <span v-html="data.description"></span><br /><br />
        <span
          >В назначении платежа указывайте
          <strong>"{{ data.purpose }}"</strong></span
        >
      </div>
    </div>

    <div class="invoice-block invoice-signature">
      <div class="invoice-block-one invoice-block-one__small invoice-bold post-input">
        {{ udata.gd_post }}
      </div>
      <div class="invoice-block-one invoice-block-one__grow">
        <div class="signature-block"></div>
        {{ udata.gd | fullToShort }}
      </div>
    </div>

    <div
      class="invoice-block invoice-signature"
      v-if="udata.gb_flag == '1'"
    >
      <div class="invoice-block-one invoice-block-one__small invoice-bold">
        Главный бухгалтер
      </div>
      <div class="invoice-block-one invoice-block-one__grow">
        <div class="signature-block"></div>
        {{ udata.gb | fullToShort }}
      </div>
    </div>
  </section>
</template>

<script>
import VueQrcode from "@chenfengyuan/vue-qrcode";
import { rubles } from "rubles";

export default {
  props: ["data"],
  name: "Invoice",
  components: {
    VueQrcode,
  },
  data: function () {
    return {
      opts: {
        width: 524,
        errorCorrectionLevel: "Q",
        margin: 1,
        type: "image/png",
        color: {
          dark: "#344d6c",
          light: "#344d6c00",
        }
      }
    };
  },
  methods: {},
  computed: {
    udata: function () {
      if (!this.data.me.inn) return this.$root.app.user;
      return this.data.me;
    },
    company: function () {
      if (!this.data.me.inn) return this.$root.app.user.data;
      return this.data.me.data;
    },
    bank: function () {
      if (!this.data.me.bank.current) return this.$root.app.user.bank;
      return this.data.me.bank;
    },
    sum: function () {
      var sum = 0;
      this.data.items.forEach((el) => {
        sum += el.cost * el.count;
      });

      return sum;
    },
    sum_b: function () {
      return Math.floor((this.data.nds == "0" ? this.nds : 0) + this.sum);
    },
    sum_k: function () {
      return Math.floor(
        ((this.data.nds == "0" ? this.nds : 0) + this.sum - this.sum_b) * 100
      );
    },
    nds: function () {
      let nds = 0;
      if (this.$root.app.user.nds == "0") return 0;

      this.data.items.forEach((el) => {
        let sum = el.count * el.cost,
          nds_value = this.$root.app.nds_types.find((x) => x.id == el.nds)
            .value,
          d = this.data.nds == "1" ? nds_value : 0;

        nds += (sum * nds_value) / (d + 100);
      });

      return nds;
    },
    nds_data: function () {
      let nds = [];
      if (this.$root.app.user.nds == "0") return 0;

      this.data.items.forEach((el) => {
        let sum = el.count * el.cost,
          nds_value = this.$root.app.nds_types.find((x) => x.id == el.nds)
            .value,
          d = this.data.nds == "1" ? nds_value : 0;
        if (!nds.find((x) => x.id == nds_value))
          nds.push({ id: nds_value, sum: 0 });

        nds.find((x) => x.id == nds_value).sum += (sum * nds_value) / (d + 100);
      });

      return nds;
    },
    sum_text: function () {
      return this.sum == 0
        ? "Ноль рублей 00 копеек"
        : rubles((this.data.nds == "0" ? this.nds : 0) + this.sum);
    },

    qrdata: function () {
      if(!this.company || !this.bank) return '';

      var params = {
        Name: this.company.name.full_with_opf,
        PersonalAcc: this.bank.rs,
        BankName: this.bank.data.name.payment,
        BIC: this.bank.data.bic,
        CorrespAcc: this.bank.data.correspondent_account,
        PayeeINN: this.company.inn,
        KPP: this.company.kpp,
        Purpose: this.data.purpose
          ? this.data.purpose
          : "Оплата счета №" + this.data.name + " от " + this.$moment(this.data.date).format('DD.MM.YYYY'),
        Sum: ((this.data.nds == "0" ? this.nds : 0) + this.sum) * 100,
      };

      var s = "ST00011";
      for (let key in params) {
        s += "|" + key + "=" + params[key];
      }
      return s;
    },
  }
};
</script>
